/**
 * Maps the plan-limit errors raised by the database triggers
 * (check_tournament_plan_limits, check_league_plan_limits, check_participant_limit)
 * to the translation key that explains the limit to the user.
 *
 * Returns null when the error is not a plan-limit error.
 */
export function getPlanLimitMessageKey(error: unknown): string | null {
  const message = getErrorMessage(error);
  if (!message.startsWith('Free plan')) return null;

  if (message.includes('private tournament')) return 'subscription.privateTournamentLimitReached';
  if (message.includes('tournaments per league')) return 'subscription.leagueTournamentLimitReached';
  if (message.includes('active tournaments')) return 'subscription.tournamentLimitReached';
  if (message.includes('tournament types')) return 'subscription.tournamentTypeProOnly';
  if (message.includes('active league')) return 'subscription.leagueLimitReached';
  if (message.includes('participants per tournament')) return 'subscription.participantLimitReached';

  return 'subscription.planLimitReached';
}

export function isPlanLimitError(error: unknown): boolean {
  return getPlanLimitMessageKey(error) !== null;
}

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const { message } = error as { message: unknown };
    return typeof message === 'string' ? message : '';
  }
  return typeof error === 'string' ? error : '';
}
